import { DialogContent, SxProps } from "@mui/material";
import React from "react";

import theme from "Theme/AppTheme";
import { sxClsx } from "utils/styleClsx";

interface ContentProps {
    sx?: SxProps;
}

export function Content({
    sx,
    children,
}: React.PropsWithChildren<ContentProps>) {
    return (
        <DialogContent
            sx={sxClsx(
                {
                    fontSize: "13px",
                    color: theme.palette.black.main,
                    backgroundColor: theme.palette.lightgray.main,
                    borderRadius: 1,
                    padding: `${theme.spacing(2)} !important`,
                },
                sx,
            )}
        >
            {children}
        </DialogContent>
    );
}
